<!-- Contenido destacado -->
<section class="section destacado__container">
	<ng-container [ngTemplateOutlet]="nuevosDestacados"></ng-container>
		<div class="col-12">
			<div class="destacado__box">

				<ng-container *ngIf="( ready$ | async ); else loading">
					<ngb-carousel class="content" *ngIf="( destacado$ | async )">
						<ng-template ngbSlide *ngFor="let contenido of ( destacado$ | async )">
							<ng-container *ngIf="contenido" [ngTemplateOutlet]="card" [ngTemplateOutletContext]="{contenido:contenido}"></ng-container>
						</ng-template>
					</ngb-carousel>
				</ng-container>

			</div>
		</div>
</section>

<!-- Card -->
<ng-template #card let-contenido="contenido">
	<div class="card__image" [routerLink]="['/principal/noticia/',contenido.rid]" [ngStyle]="getCarouselStyle( contenido )"></div>
	<div class="carousel-caption" [routerLink]="['/principal/noticia/',contenido.rid]" gtagEvent="ver-noticia" gtagCategory="noticia-destacada" [gtagLabel]="contenido.rid">
		<div class="card__author"><p>{{contenido.sector}}</p></div>
		<div class="card__categoria"><p>{{contenido.categoria}}</p></div>
		<div class="card__title"><p>{{contenido.titulo}}</p></div>
		<div class="card__text"><p>{{contenido.desc}}</p></div>
	</div>
</ng-template>

<!-- Cargando -->
<ng-template #loading>
	<div class="content loading">
		<div class="spinner-border text-info"></div>
	</div>
</ng-template>

<!-- Nuevas noticias -->
<ng-template #nuevosDestacados>
	<div *ngIf="( nuevosDestacados$ | async )" class="nuevosDestacados">
		<p>Nuevas noticias destacadas</p>
	</div>
</ng-template>

